import { useMemo } from 'react';
import COMPONENT_REGISTRY from './registry';

function SingleComponent({ item }) {
    if (!item || !item.component) {
        return (
            <div className="text-xs text-red-500">
                Invalid component schema
            </div>
        );
    }

    const Component = COMPONENT_REGISTRY[item.component];

    if (!Component) {
        return (
            <div className="text-xs text-gray-500 dark:text-gray-400">
                Unknown component: {item.component}
            </div>
        );
    }

    const props = item.props || {};
    const { context, ...componentProps } = props;

    return <Component {...componentProps} />;
}

export default function ComponentRenderer({ data }) {
    const parsed = useMemo(() => {
        if (!data) return null;
        if (typeof data === 'string') {
            try {
                return JSON.parse(data);
            } catch {
                return null;
            }
        }
        return data;
    }, [data]);

    if (!parsed) {
        return (
            <div className="text-xs text-red-500">
                Invalid component schema
            </div>
        );
    }

    if (Array.isArray(parsed)) {
        return (
            <div className="space-y-4">
                {parsed.map((item, index) => (
                    <SingleComponent key={index} item={item} />
                ))}
            </div>
        );
    }

    return <SingleComponent item={parsed} />;
}
